export default __webpack_public_path__ + "static/media/about us page_Professional Integrity-.ef0db7aa.png";